import { useContext } from "react";

import { Store } from "../../store";
import "./ViewModeToggle.css";
import { VIEW_MODES } from "./view-modes.config";

const ViewModeToggle = () => {
  const { state, dispatch } = useContext(Store);

  const handleChange = (modeValue) => {
    // Prevent switching if already in the same mode
    if (state.viewportMode === modeValue) return;

    const selected = VIEW_MODES.find((m) => m.value === modeValue);
    if (!selected) return;
    localStorage.setItem("viewportMode", selected.value);

    if (selected.showLoader) {
      dispatch({
        type: "BATCH_DISPATCH",
        payload: [
          { type: "SET_VIEWPORT_MODE", payload: selected.value },
          {
            type: "SHOW_GLOBAL_LOADER",
            payload: {
              isActive: true,
              loaderText: selected.loaderText || "Loading View...",
            },
          },
        ],
      });
    } else {
      dispatch({ type: "SET_VIEWPORT_MODE", payload: selected.value });
    }
  };

  return (
    <div className="view-toggle">
      {VIEW_MODES.map((mode) => (
        <button key={mode.value} className={`view-btn ${state.viewportMode === mode.value ? "active" : ""}`} onClick={() => handleChange(mode.value)}>
          {mode.label}
        </button>
      ))}
    </div>
  );
};

export default ViewModeToggle;
